import { id_netscapeCertExtension } from "./object_identifiers";
import { BitString } from "@peculiar/asn1-schema";
export const id_netscapeCertType = `${id_netscapeCertExtension}.1`;
export var NetscapeCertTypeFlags;
(function (NetscapeCertTypeFlags) {
    NetscapeCertTypeFlags[NetscapeCertTypeFlags["sslClient"] = 1] = "sslClient";
    NetscapeCertTypeFlags[NetscapeCertTypeFlags["sslServer"] = 2] = "sslServer";
    NetscapeCertTypeFlags[NetscapeCertTypeFlags["sMime"] = 4] = "sMime";
    NetscapeCertTypeFlags[NetscapeCertTypeFlags["objectSigning"] = 8] = "objectSigning";
    NetscapeCertTypeFlags[NetscapeCertTypeFlags["sslCa"] = 32] = "sslCa";
    NetscapeCertTypeFlags[NetscapeCertTypeFlags["sMimeCa"] = 64] = "sMimeCa";
    NetscapeCertTypeFlags[NetscapeCertTypeFlags["objectSigningCa"] = 128] = "objectSigningCa";
})(NetscapeCertTypeFlags || (NetscapeCertTypeFlags = {}));
export class NetscapeCertType extends BitString {
    toJSON() {
        const flag = this.toNumber();
        const res = [];
        if (flag & NetscapeCertTypeFlags.objectSigning) {
            res.push("objectSigning");
        }
        if (flag & NetscapeCertTypeFlags.objectSigningCa) {
            res.push("objectSigningCa");
        }
        if (flag & NetscapeCertTypeFlags.sMime) {
            res.push("sMime");
        }
        if (flag & NetscapeCertTypeFlags.sMimeCa) {
            res.push("sMimeCa");
        }
        if (flag & NetscapeCertTypeFlags.sslCa) {
            res.push("sslCa");
        }
        if (flag & NetscapeCertTypeFlags.sslClient) {
            res.push("sslClient");
        }
        if (flag & NetscapeCertTypeFlags.sslServer) {
            res.push("sslServer");
        }
        return res;
    }
    toString() {
        return `[${this.toJSON().join(", ")}]`;
    }
}
